import React from "react";
import useSmallNav from "../../../../hooks/useSmallNav";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import impreza from "../../../../assets/info/impreza-hero.jpg";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import part1 from "../../../../assets/info/subaru-impreza/impreza-pcd.png";
import part2 from "../../../../assets/info/subaru-impreza/subaru-impreza-fig-1.jpg";
import styled from "styled-components";
import { popularVehicle } from "../../../../vars/popularVehicles";
import InfoFooter from "../../../organisms/InfoFooter/InfoFooter";

const SubaruImpreza = () => {
  useSmallNav("Subaru Impreza");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Subaru Impreza"} bolder />
        <InfoHero image={impreza} />
        <InfoGrid>
          <div>
            <InfoHeader
              text={
                "Czy jesteś właścicielem i jeździsz Subaru Imprezą? Szukasz części zawieszenia lub ulepszeń zawieszenia?"
              }
            />
            <p>
              Subaru Impreza jest synonimem rajdów i zawsze spotykała się z
              burzą wśród firm tuningowych dzięki swojemu małemu silnikowi 2.0
              Turbo, dużej mocy/momentowi obrotowemu i możliwości nadawania
              znacznie droższym pojazdom wyglądu zupełnie nieadekwatnego.
            </p>
            <p>
              W miarę ewolucji Imprezy od klasycznej już serii GC i GF
              (1992-2000), przez Bug, Blob i Hawk eyed GD i GG, do GE i GH
              (2007-2011), aż w końcu do hatchbacka GV (od 2011 r.) istnieje
              Impreza na każdą kieszeń i każdy gust.
            </p>
            <p>
              W Pedders Suspension wierzymy, że możemy mieć wybór w zakresie
              prowadzenia, przyczepności i zachowania pojazdu.
            </p>
            <p>
              W ofercie Impreza możemy zaoferować proste części zamienne, części
              o zwiększonej wydajności, w tym amortyzatory i sprężyny, zestawy
              Ezifit, a także zestawy gwintowane Xa dla tych, którzy szukają
              najwyższej możliwości regulacji.
            </p>
            <p>
              Aby ułatwić Ci wybór odpowiednich części do Twojego samochodu,
              zapoznaj się z poniższymi uwagami:
            </p>
            <InfoHeader
              size="smaller"
              text={
                "Wymieniasz wiele różnych zestawów i części. Którego z nich potrzebujesz?"
              }
            />
            <p>
              Istnieje wiele różnych wariantów Imprezy. Aby wyświetlić opcje,
              wybierz właściwy z poniższego menu.
            </p>
            <p>
              Oferujemy 2 różne rodzaje amortyzatorów. Nasz amortyzator Pedders,
              który jest czarny, skutecznie zastępuje oryginalny amortyzator.
              Jeśli więc szukasz amortyzatorów zamiennych, które zastąpią
              wadliwy oryginał, to są one idealne.
            </p>
            <p>
              W ofercie posiadamy również amortyzator Pedders Sportsryder. Są
              czerwone i zostały ulepszone, aby zapewnić wrażenie bardziej
              zorientowane na wydajność. Można ich używać z oryginalnymi
              sprężynami lub naszymi sprężynami obniżającymi, aby poprawić
              wyczucie i obsługę.
            </p>
            <p>
              Sprężyny. Ponownie oferujemy zarówno standardowe amortyzatory
              zamienne (czarne), jak i obniżone elementy ulepszone (czerwone).
            </p>
            <p>
              W pełni zmontowane zestawy zawieszenia Ezifit. Oprócz powyższego
              oferujemy teraz w pełni zmontowane, gotowe do montażu zestawy
              kolumn do niektórych modeli i wariantów. Zestawy te są w pełni
              zmontowanymi kolumnami zawieszenia, więc są wyposażone w
              amortyzatory, sprężyny, mocowania górne, odbojniki i osłony,
              gotowe do bezpośredniego przykręcenia. Nie tylko zapewniają
              łatwość montażu ale również dają pewność, że wszystkie części są
              nowe, ale reprezentują wyjątkową wartość w porównaniu do zakupu
              części osobno.
            </p>
            <p>
              Zestawy gwintowane Extreme XA. Stanowią one szczyt gamy Pedders i
              oferują w pełni regulowany pakiet zawieszenia przeznaczony dla
              entuzjastów wydajności.
            </p>
            <p>
              Dalsze szczegóły dotyczące wszystkich opisanych powyżej produktów
              można znaleźć na odpowiednich stronach produktów. Jeśli jednak nie
              masz pewności, która opcja będzie dla Ciebie najlepsza, skontaktuj
              się z nami pod adresem support@pedders.eu, a my dołożymy wszelkich
              starań, aby Ci pomóc.
            </p>
            <InfoHeader
              size="smaller"
              text={"Dalsze informacje na temat wariantów Wagon i STi."}
            />
            <p>
              W stosownych przypadkach oferujemy różne części do modeli wagonów.
              Są cięższe z tyłu i mogą wykorzystywać różne przedramiona.
              Rozumiemy to i w razie potrzeby dostarczamy inne lub dodatkowe
              części.
            </p>
            <p>
              Modele STi. Często przyczyną nieporozumień są późniejsze modele
              Sti, a konkretnie 2002-2007, wyposażone w odwrócone amortyzatory
              jednorurowe. Co ważniejsze, w przednim amortyzatorze zastosowano
              szerszy dolny wspornik widełkowy. Oznacza to, że w tych modelach
              nie można montować zwykłego amortyzatora zastępczego. Samochody te
              są często określane jako samochody z „szerokim rozstawem kół”.
              Oprócz szerszego widełka, można je łatwiej rozpoznać po większym
              rozstawie kołków (PCD) wynoszącym 114 mm w porównaniu ze 100 mm we
              wszystkich innych imprezach. Jeśli nie jesteś pewien, sprawdź to
              najpierw (patrz rysunek poniżej, gdzie linia wynosi 114,3).
            </p>
            <p>
              Firma Pedders wyprodukowała zestaw Ezifit specjalnie dla tego
              modelu.
            </p>
            <StyledImgParts src={part1} />
            <Gray>
              <InfoHeader
                size="smaller"
                text={
                  "Subaru Impreza GD Zawiera zestaw obniżający kolumnę WRX SportsRyder EziFit"
                }
              />
              <div>
                <StyledImgParts
                  src={part2}
                  alt="Subaru Impreza GD Zawiera zestaw obniżający kolumnę WRX SportsRyder EziFit"
                  style={{ height: "255px", width: "270px" }}
                />
              </div>
              <p style={{ fontWeight: "bolder" }}>
                Nie chcesz zestawu do gwintowania, ale nadal chcesz ulepszonego
                zawieszenia?
              </p>
              <p>
                W takim razie zestaw zawieszenia Pedders SportsRyder EziFit jest
                dla Ciebie idealny. Nasz w pełni zmontowany zestaw obniżający
                skróci czas montażu i znacznie poprawi właściwości jezdne Twojej
                Imprezy!
              </p>
              <hr />
              <StyledLink href="https://pedders.eu/details/803035">
                Zobacz
              </StyledLink>
            </Gray>
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/m0FEqfSnHLU"
              title={"Subaru Impreza Video 1"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/g1aSCo4S2_E"
              title={"Subaru Impreza Video 2"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/KnT6sI4QaYk"
              title={"Subaru Impreza Video 3"}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Subaru")
              .models.find((e) => e.display === "Impreza")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
          </div>
        </InfoGrid>
        {/* <InfoFooter make="Subaru" model="Impreza" /> */}
      </Container>
    </section>
  );
};

export default SubaruImpreza;

const StyledImgParts = styled.img`
  height: 300px;
  width: 160px;
`;

const StyledLink = styled.a`
  background-color: #dc3332;
  color: #fff;
  border-radius: 4px;
  padding: 8px 12px;
  text-decoration: none;
  font-weight: 600;
`;

const Gray = styled.div`
  padding: 25px;
  border-radius: 5px;
  background-color: #f4f4f4;
  margin: 30px 0;
`;
